import React, { lazy } from 'react';
import SystemSetting from '../pages/rnslab/SystemSetting';
import DashboardPage from '../pages/dashboard/page/DashboardPage';
import Icru from '../pages/icru/icru';
import Test from '../pages/icru/test';
import Question from '../pages/icru/question';
import Loading from '../pages/icru/loading';
import Report from '../pages/icru/report';

const Login = lazy(() => import('../pages/CommonMenu/Login/login'));
const SignUp = lazy(() => import('../pages/CommonMenu/SignUp/SignUp'));
const PasswdReset = lazy(() => import('../pages/CommonMenu/Login/PasswdReset'));
const Intro = lazy(() => import('../pages/icru/intro'));
const Home = lazy(() => import('../pages/icru/home'));
const CollectedData = lazy(() => import('../pages/rnslab/collectedData'));
const UserList = lazy(() => import('../pages/rnslab/userList'));
const GroupList = lazy(() => import('../pages/rnslab/groupList'));
const WorkerList = lazy(() => import('../pages/rnslab/workerList'));
const DeviceList = lazy(() => import('../pages/rnslab/deviceList'));
const DeviceSettings = lazy(() => import('../pages/rnslab/deviceSettings'));
const Firmware = lazy(() => import('../pages/rnslab/firmware'));
const DeviceCommand = lazy(() => import('../pages/rnslab/deviceCommand'));

const contents = {
	intro: {
		id: 'intro',
		text: '인트로',
		type: 'withOutAsidePage',
		icon: 'Intro',
		path: '/intro',
		element: <Intro />,
		exact: true,
		subMenu: null,
	},
	home: {
		id: 'home',
		text: '홈',
		type: 'withOutAsidePage',
		icon: 'Home',
		path: '/home',
		element: <Home />,
		exact: true,
		subMenu: null,
	},
	icru: {
		id: 'icru',
		text: '홈',
		type: 'withOutAsidePage',
		icon: 'Icru',
		path: '/icru',
		element: <Icru />,
		exact: true,
		subMenu: null,
	},
	test: {
		id: 'test',
		text: '홈',
		type: 'withOutAsidePage',
		icon: 'Test',
		path: '/test',
		element: <Test />,
		exact: true,
		subMenu: null,
	},
	question: {
		id: 'question',
		text: '홈',
		type: 'withOutAsidePage',
		icon: 'Question',
		path: '/question',
		element: <Question />,
		exact: true,
		subMenu: null,
	},
	loading: {
		id: 'loading',
		text: '홈',
		type: 'withOutAsidePage',
		icon: 'Loading',
		path: '/loading',
		element: <Loading />,
		exact: true,
		subMenu: null,
	},
	report: {
		id: 'report',
		text: '홈',
		type: 'withOutAsidePage',
		icon: 'Report',
		path: '/report',
		element: <Report />,
		exact: true,
		subMenu: null,
	},
	login: {
		id: 'login',
		text: '로그인',
		type: 'withOutAsidePage',
		icon: 'Login',
		path: '/login',
		element: <Login />,
		exact: true,
		subMenu: null,
	},
	signup: {
		id: 'signup',
		text: '회원가입',
		type: 'withOutAsidePage',
		icon: 'Signup',
		path: '/signup',
		element: <SignUp />,
		exact: true,
		subMenu: null,
	},
	passwordReset: {
		id: 'passwordReset',
		text: '비밀번호찾기',
		type: 'withOutAsidePage',
		icon: 'passwordReset',
		path: '/passwordReset',
		element: <PasswdReset />,
		exact: true,
		subMenu: null,
	},
	dashboard: {
		id: 'dashboard',
		text: '대시보드',
		type: 'superadmin',
		icon: 'BarChart',
		path: '/dashboard',
		element: <DashboardPage />,
		exact: true,
		permissions: ['USER', 'GROUP'],
		subMenu: null,
	},
	collectedData: {
		id: 'collectedData',
		text: '수집 데이터',
		type: 'user',
		icon: 'Preview',
		path: '/collectedData',
		element: <CollectedData />,
		exact: true,
		permissions: ['USER', 'GROUP'],
		subMenu: null,
	},
	userDataList: {
		id: 'userDataList',
		text: '사용자 관리',
		type: 'group',
		icon: 'ManageAccounts',
		path: '/userDataList',
		element: <UserList />,
		exact: true,
		permissions: ['GROUP'],
		subMenu: null,
	},
	groupDataList: {
		id: 'groupDataList',
		text: '그룹 관리',
		type: 'superadmin',
		icon: 'Group',
		path: '/groupDataList',
		element: <GroupList />,
		exact: true,
		permissions: [],
		subMenu: null,
	},
	wokerDataList: {
		id: 'wokerDataList',
		text: '작업자 관리',
		type: 'user',
		icon: 'Engineering',
		path: '/wokerDataLists',
		element: <WorkerList />,
		exact: true,
		permissions: [],
		subMenu: null,
	},
	// deviceDataList: {
	// 	id: 'deviceDataList',
	// 	text: '기기 목록 조회',
	// 	type: 'user',
	// 	icon: 'SpeakerPhone',
	// 	path: '/deviceDataList',
	// 	element: <DeviceList />,
	// 	exact: true,
	// 	subMenu: null,
	// },
	deviceSettings: {
		id: 'deviceSettings',
		text: '기기 관리',
		type: 'user',
		icon: 'AppSettingsAlt',
		path: '/deviceSettings',
		element: <DeviceSettings />,
		exact: true,
		permissions: ['USER', 'GROUP'],
		subMenu: null,
	},
	deviceInstall: {
		id: 'deviceInstall',
		text: '기기 설치 정보',
		type: 'user',
		icon: 'PermDeviceInformation',
		path: '/deviceInstall',
		element: <DeviceList />,
		exact: true,
		permissions: [],
		subMenu: null,
	},
	deviceCommand: {
		id: 'deviceCommand',
		text: '기기 명령 정보',
		type: 'user',
		icon: 'ConnectedTv',
		path: '/deviceCommand',
		element: <DeviceCommand />,
		exact: true,
		permissions: [],
		subMenu: null,
	},
	firmware: {
		id: 'firmware',
		text: '펌웨어 관리',
		type: 'user',
		icon: 'Save',
		path: '/firmware',
		element: <Firmware />,
		exact: true,
		permissions: [],
		subMenu: null,
	},
	systemSetting: {
		id: 'systemSetting',
		text: '시스템 설정',
		type: 'user',
		icon: 'Settings',
		path: '/systemSetting',
		element: <SystemSetting />,
		exact: true,
		permissions: [],
		subMenu: null,
	},
}

export default contents;
